import { RestrictedAccountObject } from "./restricted-account-object.model";
import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";

export abstract class RestrictedAccountObjectApiFacade<T extends RestrictedAccountObject> extends AccountObjectApiFacade<T> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.api-facade.ts